module.exports = __webpack_public_path__ + "img/all.5c582da2.png";